// ─── Feuille : page « RÉCURRENCES » du calendrier actif ───────────
// Extrait d'EcranCalendrier (découpage). Liste des séries récurrentes :
// swipe ✏️ (éditer la série) / 🗑️🗑️ (supprimer la série), tap = fiche info.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, LigneSwipe, useUI, useT } from '@mop/core';
import { JOURS_SEM } from './services/evenements';

const fmtJour = (dk) => { if (!/^\d{4}-\d{2}-\d{2}$/.test(dk || '')) return '—'; const [y, m, d] = dk.split('-'); return `${d}/${m}/${y}`; };

export default function FeuilleRecurrences({
  visible, recs, edit, joursL, repetLabel, erreurLecture, onFermer, onEditer, onSupprimerSerie, onOuvrirFiche,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <Feuille visible={visible} titre={t('historique.filtre_recurrence')} emoji="🔁" onFermer={onFermer}>
      {!!erreurLecture && (
        <View style={s.bandeau}>
          <Text style={s.bandeauTxt}>⚠️ {t('calendrier.erreurLectureEvenements')}</Text>
          <Text style={s.bandeauDet}>{erreurLecture}</Text>
        </View>
      )}
      {erreurLecture ? null : recs.length === 0
        ? <Text style={s.vide}>{t('calendrier.aucuneRecurrence')}</Text>
        : recs.map(r => {
          const rc = r.recurrence || {};
          const k = Number(rc.intervalle) || (rc.type === 'bimensuel' ? 2 : 1);
          const lbl = (rc.type === 'hebdo' && k > 1) ? t('calendrier.repetNSemaines', { n: k })
            : (rc.type === 'mensuel' && k > 1) ? t('calendrier.repetNMois', { n: k })
            : (rc.type === 'quotidien' && k > 1) ? t('calendrier.repetNJours', { n: k })
            : repetLabel(rc.type || 'quotidien');
          const js = rc.joursSemaine || [];
          const jTxt = js.length ? ` · ${JOURS_SEM.map((j, ji) => js.includes(j.i) ? joursL[ji] : null).filter(Boolean).join(' ')}` : '';
          return (
            <LigneSwipe key={r.id} espacement={8} enabled={edit}
              onEditer={edit ? () => onEditer(r) : undefined}
              onSupprimerSerie={edit ? () => onSupprimerSerie(r) : undefined}>
              <TouchableOpacity style={s.recRow} activeOpacity={0.7} onPress={() => onOuvrirFiche(r)}>
                <Text style={{ fontSize: 18 }}>🔁</Text>
                <View style={{ flex: 1 }}>
                  <Text style={s.recNom} numberOfLines={1}>{r.titre}{r.actif === false ? t('calendrier.inactifSuffixe') : ''}</Text>
                  <Text style={s.recSous} numberOfLines={1}>
                    {lbl}{jTxt}{rc.heure || r.heure ? ` · ${rc.heure || r.heure}` : ''}{rc.dateDebut ? ` · ${t('calendrier.desDate', { date: fmtJour(rc.dateDebut) })}` : ''}{rc.dateFin ? ` → ${fmtJour(rc.dateFin)}` : ''}
                  </Text>
                </View>
              </TouchableOpacity>
            </LigneSwipe>
          );
        })}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  vide: { fontSize: 13, color: UI.faint, fontStyle: 'italic' },
  recRow: { flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: UI.card, borderRadius: 11, borderWidth: 1, borderColor: UI.border, padding: 12 },
  recNom: { flex: 1, fontSize: 14.5, fontWeight: '700', color: UI.ink },
  recSous: { fontSize: 11.5, color: UI.muted, marginTop: 1 },
  bandeau:    { backgroundColor: UI.dangerTint || '#fdecec', borderRadius: 12, borderWidth: 0.5, borderColor: UI.danger || '#e5484d', padding: 11, marginBottom: 10 },
  bandeauTxt: { fontSize: 13, fontWeight: '800', color: UI.danger || '#e5484d' },
  bandeauDet: { fontSize: 11.5, color: UI.muted, marginTop: 3 },
});
